import { useCallback, useRef } from "react";

interface UseLazyLoadBookmarksArgs {
    isLoading: boolean;
    noRecordsRemaining: boolean;
    onPageNext: () => void;
}

const useLazyLoadBookmarks = (args: UseLazyLoadBookmarksArgs) => {
    const { isLoading, noRecordsRemaining, onPageNext } = args;

    const intersectionObserverRef = useRef<IntersectionObserver | null>(null);

    const observerRef = useCallback(
        (node) => {
            if (node !== null && !isLoading && !noRecordsRemaining) {
                if (intersectionObserverRef.current != null)
                    intersectionObserverRef.current.disconnect();

                intersectionObserverRef.current = new IntersectionObserver(
                    (entries: IntersectionObserverEntry[]) => {
                        if (entries.some((e) => e.isIntersecting))
                            if (!noRecordsRemaining && !isLoading) {
                                onPageNext();
                            }
                    },
                    {
                        threshold: 1.0,
                    }
                );
                intersectionObserverRef.current.observe(node);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isLoading, noRecordsRemaining, onPageNext]
    );

    return { observerRef };
};

export default useLazyLoadBookmarks;
